import { useEffect, useRef } from 'react';

const FIBONACCI_INTERVALS = [3000, 5000, 8000, 13000, 21000];
const MAX_IDLE_TIME = 5 * 60 * 1000; // 5 minutes

const useProgressivePolling = ({ enabled, callback }) => {
  const timeoutRef = useRef(null);
  const indexRef = useRef(0);
  const inFlightRef = useRef(false);
  const idleStartRef = useRef(Date.now());
  const isTabActiveRef = useRef(!document.hidden);

  // Handle tab visibility
  useEffect(() => {
    const handleVisibility = () => {
      isTabActiveRef.current = !document.hidden;

      // Resume immediately when tab becomes active
      if (isTabActiveRef.current && enabled) {
        indexRef.current = 0;
        idleStartRef.current = Date.now();
        scheduleNext();
      } else {
        clearTimeout(timeoutRef.current);
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () =>
      document.removeEventListener('visibilitychange', handleVisibility);
  }, [enabled]);

  const scheduleNext = () => {
    clearTimeout(timeoutRef.current);

    const delay = 5000;
    console.log(
      new Date().toISOString(),
      'Scheduling next poll in',
      delay,
      'ms',
    );

    timeoutRef.current = setTimeout(runPoll, delay);
  };

  const runPoll = async () => {
    if (!enabled || !isTabActiveRef.current) return;

    // Stop after 5 minutes of no updates
    if (Date.now() - idleStartRef.current >= MAX_IDLE_TIME) return;

    if (inFlightRef.current) return;
    inFlightRef.current = true;

    const hasUpdates = await callback();

    inFlightRef.current = false;

    if (hasUpdates) {
      indexRef.current = 0;
      idleStartRef.current = Date.now();
    } else {
      indexRef.current += 1;
    }

    scheduleNext();
  };

  useEffect(() => {
    if (!enabled) return;

    idleStartRef.current = Date.now();
    indexRef.current = 0;
    scheduleNext();

    return () => {
      clearTimeout(timeoutRef.current);
      inFlightRef.current = false;
    };
  }, [enabled, callback]);
};

export default useProgressivePolling;
